import React from "react";
import picMe from "../assets/png/pheaktra-profile.jpg";
import { Link } from "react-router-dom";
import { header } from "../constants/header";
import { logo } from "../constants/home";
import { contact } from "../constants/footer";

const Footer = () => {
  return (
    <div className="container-fluid bg-dark text-white">
      <div className="container">
        <div className="container-fluid bg-dark text-light py-5">
          <div className="row align-items-start gy-4">
            <div className="col-12 col-sm-12 col-md-6 col-lg-3 d-flex align-items-start">
              <img
                className="picMe rounded-circle me-3"
                src={picMe}
                alt="Profile"
                style={{ width: "70px", height: "70px", objectFit: "cover" }}
              />
              <div>
                <h5 className="fw-bold mb-1 font-Style">Ry Pheaktra</h5>
                <p className="mb-2 text-secondary">Web Developer</p>
                <div className="d-flex flex-wrap gap-2">
                  {logo.map((items, index) => (
                    <Link
                      key={index}
                      target="_blank"
                      to={items.path}
                      className="btn btn-outline-light btn-sm rounded-circle d-flex align-items-center justify-content-center"
                      style={{ width: "36px", height: "36px" }}
                    >
                      {items.icons}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-6 col-md-3 col-lg-2">
              <h6 className="text-uppercase fw-bold mb-3">Pages</h6>
              {header.map((items, index) => (
                <Link
                  key={index}
                  to={items.path}
                  className="d-block text-decoration-none text-secondary mb-2 nav-link-footer font-Style"
                >
                  {items.title}
                </Link>
              ))}
            </div>
            <div className="col-6 col-md-3 col-lg-3">
              <h6 className="text-uppercase fw-bold mb-3">Services</h6>
              <ul className="list-unstyled text-secondary">
                <li className="mb-2">Web Development</li>
                <li className="mb-2">Front-End Development</li>
              </ul>
            </div>
            <div className="col-12 col-md-12 col-lg-4">
              <h6 className="text-uppercase fw-bold mb-3">Contact</h6>
              <ul className="list-unstyled text-secondary">
                {contact.map((items, index) => (
                  <li className="mb-2 d-flex align-items-center" key={index}>
                    <span className="me-2 fs-5">{items.icon}</span>
                    {items.title}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <hr className="border-secondary my-4" />
          <p className="text-center mb-0 text-secondary fw-semibold small">
            © 2024 | All Rights Reserved By{" "}
            <span className="text-light">Ry Pheaktra</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
